<ul *ngIf="!options.hideBalance">
	<obg-accordion [disabled]="!options.enableAccordion" [expanded]="expandedKeys" (toggleChange)="(onToggleChange)">
		<obg-accordion-header [key]="fundsOverview">
			<li class="obg-m-funds-overview-total">
				<p
					class="obg-m-funds-overview-label"
					data-test-id="user-summary-username"
					test-id="user-summary-username"
					obgSensitiveData
				>
					{{ customer?.profile?.firstName }} {{ customer?.profile?.lastName | truncate: 2 : "." }}
				</p>
				<span class="obg-m-funds-overview-value obg-m-funds-overview-total-value">
					<span
						*ngIf="balanceHashedEnabled"
						test-id="user-summary-hash-balance-button"
						class="ico ico-show-hide"
						[class]="isBalanceHashed ? 'ico-show' : 'ico-hide'"
						(click)="hashBalance($event, isBalanceHashed)"
					></span>
					<p
						class="obg-m-funds-overview-total-value-value"
						data-test-id="user-summary-balance"
						test-id="user-summary-balance"
						obgSensitiveData
					>
						{{ balance?.totalAmount | obgCurrency: undefined : undefined : undefined : isBalanceHashed }}
					</p>
					<span
						*ngIf="options.enableAccordion"
						class="ico"
						[class]="isExpandedAccordion ? 'ico-chevron-up' : 'ico-chevron-down'"
					></span>
				</span>
			</li>
			<li
				class="obg-m-funds-overview-pin"
				test-id="user-summary-pin-code"
				*ngIf="customer?.basicInformation?.pinCode"
			>
				<p>
					{{ "user-summary.pin-code" | translate }}:
					<strong obgSensitiveData>{{ customer?.basicInformation?.pinCode }}</strong>
				</p>
			</li>
		</obg-accordion-header>

		<obg-accordion-content *ngIf="(isAamsJurisdiction$ | async) && balance" [key]="fundsOverview">
			<li
				*ngIf="
					(balance.lockedMoney !== undefined || balance.availableToWithdraw !== undefined) &&
					options.bonusVisible
				"
			>
				<p class="obg-m-funds-overview-label">{{ "user-summary.real-money" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-real-money"
					test-id="user-summary-real-money"
					obgSensitiveData
				>
					{{
						(balance?.lockedMoney?.amount ?? 0.0) + (balance?.availableToWithdraw?.amount ?? 0.0)
							| obgCurrency: undefined : undefined : undefined : isBalanceHashed
					}}
				</p>
			</li>
			<li *ngIf="balance.specialBonusMoney !== undefined && options.bonusVisible">
				<p class="obg-m-funds-overview-label">{{ "user-summary.fun-bonus" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-special-bonus"
					test-id="user-summary-special-bonus"
					obgSensitiveData
				>
					{{
						balance?.specialBonusMoney?.amount
							| obgCurrency: undefined : undefined : undefined : isBalanceHashed
					}}
				</p>
			</li>
			<li *ngIf="balance.realBonusMoney !== undefined && options.bonusVisible">
				<p class="obg-m-funds-overview-label">{{ "user-summary.real-bonus" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-real-bonus"
					test-id="user-summary-real-bonus"
					obgSensitiveData
				>
					{{
						balance?.realBonusMoney?.amount
							| obgCurrency: undefined : undefined : undefined : isBalanceHashed
					}}
				</p>
			</li>
			<li *ngIf="balance.availableToWithdraw !== undefined">
				<p class="obg-m-funds-overview-label">{{ "user-summary.total-withdrawable" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-total-withdrawable"
					test-id="user-summary-total-withdrawable"
					obgSensitiveData
				>
					{{
						balance?.availableToWithdraw?.amount
							| obgCurrency: undefined : undefined : undefined : isBalanceHashed
					}}
				</p>
			</li>
		</obg-accordion-content>

		<obg-accordion-content *ngIf="!(isAamsJurisdiction$ | async) && balance" [key]="fundsOverview">
			<li *ngIf="balance.withdrawableAmount !== undefined">
				<p class="obg-m-funds-overview-label">{{ "user-summary.withdrawable" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-withdrawable"
					test-id="user-summary-withdrawable"
					obgSensitiveData
				>
					{{ balance?.withdrawableAmount | obgCurrency: undefined : undefined : undefined : isBalanceHashed }}
				</p>
			</li>
			<li *ngIf="balance.lockedAmount !== undefined && options.bonusVisible">
				<p class="obg-m-funds-overview-label">{{ "user-summary.locked" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-locked"
					test-id="user-summary-locked"
					obgSensitiveData
				>
					{{ balance?.lockedAmount | obgCurrency: undefined : undefined : undefined : isBalanceHashed }}
				</p>
			</li>
			<li *ngIf="balance.bonusAmount !== undefined && options.bonusVisible">
				<p class="obg-m-funds-overview-label">{{ "user-summary.bonus" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-bonus"
					test-id="user-summary-bonus"
					obgSensitiveData
				>
					{{ balance?.bonusAmount | obgCurrency: undefined : undefined : undefined : isBalanceHashed }}
				</p>
			</li>
			<li *ngIf="balance?.reservedForTax !== undefined">
				<p class="obg-m-funds-overview-label">{{ "user-summary.reserved-for-tax" | translate }}</p>
				<p
					class="obg-m-funds-overview-value"
					data-test-id="user-summary-reserved-for-tax"
					test-id="user-summary-reserved-for-tax"
					obgSensitiveData
				>
					{{ balance?.reservedForTax | obgCurrency: undefined : undefined : undefined : isBalanceHashed }}
				</p>
			</li>
		</obg-accordion-content>
	</obg-accordion>
</ul>

<div *ngIf="!showKycNotification; else kycNotification" class="obg-m-funds-overview-buttons">
	<a
		mat-flat-button
		*ngIf="!options.hideWithdraw"
		color="primary"
		test-id="funds-overview-withdraw-button"
		data-test-id="funds-overview-withdraw-button"
		[obgRouteLink]="withdrawRoute"
		[obgInteraction]="withdrawTrackingData"
		[ngClass]="{ 'funds-overview-withdraw-button': isAlternativeButtonStyleEnabled }"
		(click)="withdraw.emit()"
	>
		{{ "general.withdraw" | translate }}
	</a>

	<a
		mat-flat-button
		color="accent"
		data-test-id="funds-overview-deposit-button"
		[obgRouteLink]="depositRoute"
		[obgInteraction]="depositTrackingData"
		[obgRouteLinkOptions]="depositRouteOptions"
		[ngClass]="{ 'funds-overview-deposit-button': isAlternativeButtonStyleEnabled }"
		(click)="deposit.emit()"
	>
		{{ "general.deposit" | translate }}
	</a>
</div>

<ng-template #kycNotification>
	<obg-m-kyc-notification
		test-id="kyc-notification"
		hideVerifyButton
		[notificationData]="notificationData"
		is18Plus
	></obg-m-kyc-notification>
	<a mat-flat-button color="accent" test-id="verify-button" [obgRouteLink]="verificationRoute">
		{{ "kyc-verify-popup.complete-registration" | translate }}
	</a>
</ng-template>
